/**
 * Copyright © WarmHeart Intelligence Technology Group (Jiangsu) Co.,Ltd Company, Limited.
 * All Rights Reserved
 */
import loadingComponent from './loading.vue'

let Loading = {}

Loading.installed = false

Loading.install = function(Vue){
  const LoadingConstructor = Vue.extend(loadingComponent)
  const instance = new LoadingConstructor()

  Vue.prototype.$loading = {
    show() {
      if(!Loading.installed){
        Loading.installed = true;
        instance.$mount(document.createElement('div'));
        document.body.appendChild(instance.$el);
      }
      instance.show = true
    },
    hide(){
      instance.show = false
    }
  }
}

export default Loading




// WEBPACK FOOTER //
// ./src/assets/csui/components/loading/index.js